<div class="bg-overlay-modal flex flex-col max-h-[calc(100vh-2px)] overflow-y-auto overflow-x-hidden">
  <mi-round-button
    class="absolute right-4 top-4"
    size="sm"
    icon="mi2-close"
    [ariaLabel]="'cl_chat.close' | translate"
    [tooltip]="'cl_chat.close' | translate"
    tooltipPosition="top"
    (clicked)="cancelClick()"
    data-e2e="base-modal-close-button"
  ></mi-round-button>

  @if (title()) {
    <h2 id="message-info-title" class="font-semibold text-lg py-[16px] text-center w-min min-w-full mb-0 flex-shrink-0">
      {{ title() }}
    </h2>
  }

  @if (item()) {
    <div class="relative max-w-[513px] overflow-y-auto flex-grow rounded-2xl border border-surface-100 m-4 p-2 pb-3">
      <chat-item
        [item]="item()"
        [isContinuation]="false"
        [maxImageSize]="maxImageSize()"
        [dateTimeLocale]="dateTimeLocale()"
        [previewMode]="true"
        [config]="config()"
      >
      </chat-item>
    </div>
  }

  <div class="mt-4 mr-7 -mb-[18px] ml-auto z-[2]">
    <!-- check mark delivered indicator -->
    <div
      class="inline-flex flex-row items-center justify-center bg-surface-600 dark:bg-surface-100 rounded-full w-5 h-5 border border-solid border-surface-0 dark:border-surface-950 [animation:checkmarksAnimation_1s_1] ml-2"
      [pTooltip]="'cl_chat.delivered' | translate"
      tooltipPosition="top"
      container="body"
    >
      <i class="mi2-check text-[8px] text-surface-0 dark:text-surface-950"></i>
    </div>
    <!-- check mark read indicator -->
    @if (isReadByAll()) {
      <div
        class="inline-flex flex-row items-center justify-center bg-surface-600 dark:bg-surface-100 rounded-full w-5 h-5 border border-solid border-surface-0 dark:border-surface-950 [animation:checkmarksAnimation_1s_1] -ml-2"
        [pTooltip]="'cl_chat.read' | translate"
        tooltipPosition="top"
        container="body"
      >
        <i class="mi2-check text-[8px] text-surface-0 dark:text-surface-950"></i>
      </div>
    }
  </div>

  @if (readList()?.length > 0) {
    <div class="z-[1]">
      <div class="pl-5 text-color font-bold uppercase text-sm mb-2.5">{{ 'cl_chat.readBy' | translate }}:</div>
      <ul class="list-none px-5 py-0 overflow-x-hidden max-h-[150px] mb-3.5">
        @for (r of readList(); track r.userId) {
          <li class="flex overflow-hidden mr-2.5 mb-2.5 last:mb-0 font-semibold text-color text-xs items-center">
            <mi-avatar
              [hash]="r.userId | hash"
              [name]="r.name"
              [initials]="r.name | initials"
              [photoUrl]="r.imgSrc"
              styleClass="!w-[30px] !h-[30px] !text-xs !flex-shrink-0"
            >
            </mi-avatar>
            <span class="text-base max-[18.75rem]:text-xs overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">{{
              r.name
            }}</span>
          </li>
        }
      </ul>
    </div>
  }

  @if (deliveredList()?.length > 0 && !isReadByAll()) {
    <div class="z-[1]">
      <div class="pl-5 text-color font-bold uppercase text-sm mb-2.5">{{ 'cl_chat.deliveredTo' | translate }}:</div>
      <ul class="list-none px-5 py-0 overflow-x-hidden max-h-[150px] mb-3.5">
        @for (d of deliveredList(); track d.userId) {
          <li class="flex overflow-hidden mr-2.5 mb-2.5 last:mb-0 font-semibold text-color text-xs items-center">
            <mi-avatar
              [hash]="d.userId | hash"
              [name]="d.name"
              [initials]="d.name | initials"
              [photoUrl]="d.imgSrc"
              styleClass="!w-[30px] !h-[30px] !text-xs !flex-shrink-0"
            >
            </mi-avatar>
            <span class="text-base max-[18.75rem]:text-xs overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">{{
              d.name
            }}</span>
          </li>
        }
      </ul>
    </div>
  }
</div>
